import { useCallback, useEffect } from "react";

import { Flex } from "@chakra-ui/react";
import { useLocation, useMatch, useNavigate } from "react-router";
import { useShallow } from "zustand/react/shallow";

import { routes } from "config/routes";
import { ProductsSearchComponent } from "flows/Inbound/components/ProductsSearchComponent";
import { ProductsSearchInboundUnitsResultsList } from "flows/Inbound/components/ProductsSearchInboundUnitsResultsList";
import { ProductsSearchNoEANSubcategories } from "flows/Inbound/components/ProductsSearchNoEANSubcategories";
import { useInboundStore } from "flows/Inbound/stores/inboundStore/useInboundStore";
import { Page } from "shared/components/Page";
import {
  ProductSearchActionTypes,
  useProductSearchStore,
} from "shared/stores/useProductSearchStore";

export function ManualProductsSearchPage() {
  const { pathname } = useLocation();
  const isInboundDroppingManualProductsSearchPage =
    useMatch(routes.inbound.droppingManualSearch)?.pathname === pathname;

  const navigate = useNavigate();
  const { sharedListName } = useInboundStore(
    useShallow((state) => ({
      sharedListName: state.sharedListName,
    })),
  );
  const { textSearch, activeState, setActivateTextSearch, resetTextSearch } = useProductSearchStore(
    useShallow((state) => ({
      textSearch: state.textSearch,
      activeState: state.activeState,
      setActivateTextSearch: state.setActivateTextSearch,
      resetTextSearch: state.resetTextSearch,
    })),
  );

  useEffect(() => {
    if (isInboundDroppingManualProductsSearchPage) return;

    if (!sharedListName) navigate(routes.inbound.root);
  }, [navigate, sharedListName, isInboundDroppingManualProductsSearchPage]);

  const activateTextSearch = useCallback(() => {
    setActivateTextSearch();
  }, [setActivateTextSearch]);

  const cancelSearchFlow = useCallback(() => {
    resetTextSearch();
    const to = isInboundDroppingManualProductsSearchPage
      ? routes.inbound.dropping
      : routes.inbound.preDropping;
    navigate(to);
  }, [navigate, resetTextSearch, isInboundDroppingManualProductsSearchPage]);

  const shouldShowTextSearchResults =
    textSearch && activeState === ProductSearchActionTypes.RESOLVE_TEXT_SEARCH;

  return (
    <Page h="100%" pos="relative" isFull isBgGrey data-testid="inbound-manual-search-page">
      <Flex direction="column" justify="flex-start" h="100%" width="100%">
        <ProductsSearchComponent
          isSearchFlowActive
          activateTextSearch={activateTextSearch}
          cancelSearchFlow={cancelSearchFlow}
        />
        {shouldShowTextSearchResults ? (
          <ProductsSearchInboundUnitsResultsList
            listType={isInboundDroppingManualProductsSearchPage ? "dropping" : "pre-dropping"}
          />
        ) : (
          <ProductsSearchNoEANSubcategories />
        )}
      </Flex>
    </Page>
  );
}
